// extracted by mini-css-extract-plugin
export default {"root":"BarChart_root__mXEjO","wrapper":"BarChart_wrapper__IIt9O"};